import React from 'react';
import { Link } from 'react-router-dom';
import { APPSTORE_URL } from '../../data/introFeatures';
import logoLine from '../../images/logo/logo_line.svg';
import './IntroFooter.scss';

const IntroFooter = () => {
    return (
        <footer className="intro-footer">
            <div className="intro-footer__inner">
                <div className="intro-footer__brand">
                    <img src={logoLine} alt="온리플" className="intro-footer__logo-img" />
                    <p>쌓아둔 리뷰가 매출이 되는, 가장 빠른 길.</p>
                </div>
                <div className="intro-footer__col">
                    <h6>제품</h6>
                    <Link to="/intro/review">리뷰 관리</Link>
                    <Link to="/intro/widget">리뷰 위젯</Link>
                    <Link to="/intro/booster">작성 유도</Link>
                    <Link to="/intro/ai">AI 기능</Link>
                    <Link to="/intro/design">콘텐츠 도구</Link>
                </div>
                <div className="intro-footer__col">
                    <h6>시작하기</h6>
                    <a href={APPSTORE_URL} target="_blank" rel="noopener noreferrer">카페24 앱스토어</a>
                    <a href={APPSTORE_URL} target="_blank" rel="noopener noreferrer">무료 사용하기</a>
                    <Link to="/signIn">로그인</Link>
                </div>
                <div className="intro-footer__col">
                    <h6>고객지원</h6>
                    <a href="https://onnomad.co.kr/embed/chat?service=온리플" target="_blank" rel="noopener noreferrer">상담 채팅</a>
                    <Link to="/serviceAgree">이용약관</Link>
                    <Link to="/privateAgree">개인정보처리방침</Link>
                </div>
            </div>
            <div className="intro-footer__bottom">
                <span>© {new Date().getFullYear()} ONNOMADS. All rights reserved.</span>
            </div>
        </footer>
    );
};

export default IntroFooter;
